import React from "react";
import { toast } from "react-toastify";
import { oneKlicks } from "../../../../../SDK/oneclick";
import { getuserdata } from "../../../../../services/apiService";

const Doctors = () => {
    const handleRemoveAll = async (e) => {
        e.preventDefault();
        try {
            const userId = await getuserdata("id");
            if (!userId) {
                toast.error("User not found. Please login again.");
                return;
            }

            const tableSchema = "";
            const tableName = "wishlist";
            const conditions = { user_id: userId };

            const response = await oneKlicks.delete(tableSchema, tableName, conditions);
            if (response?.success) {
                toast.success("All saved doctors removed");
                // Optionally: trigger a reload/refetch if list is rendered
            } else {
                toast.error("Failed to remove saved doctors");
            }
        } catch (err) {
            console.error("Remove all saved doctors error:", err);
            toast.error("Something went wrong while removing");
        }
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-docsettinghold tab-pane active fade show" id="dc-security">
                <div className="dc-docsettings dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle dc-titlewithicon">
                        <h3>Saved Doctors</h3>
                        <a href="#" onClick={handleRemoveAll} data-itme-type="_saved_doctors" className="dc-clicksave dc-clickremoveall">
                            <i className="lnr lnr-cross"></i>
                            Remove all saved doctors
                        </a>
                    </div>
                    <div className="dc-docsettingscontent dc-sidepadding">
                        <div className="dc-searchresult-grid dc-searchresult-list dc-searchvlistvtwo">
                            <div className="dc-emptydata-holder">
                                <div className="dc-emptydata">
                                    <div className="dc-emptydetails dc-empty-saved-doctors">
                                        <span></span>
                                        <em>No saved doctors yet.</em>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Doctors;


